import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

class TimeConverter {
  constructor() {
    this.userTimeZone = dayjs.tz.guess();
  }

  // 設置用戶時區
  setUserTimeZone(timeZone) {
    this.userTimeZone = timeZone;
  }

  // UTC 到本地時間
  utcToLocal(utcTime, format = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs(utcTime).tz(this.userTimeZone).format(format);
  }

  // 本地時間到 UTC
  localToUtc(localTime, format = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs.tz(localTime, this.userTimeZone).utc().format(format);
  }

  // 格式化時間
  formatTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs(time).format(format);
  }

  // 獲取當前 UTC 時間
  getCurrentUtc(format = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs().utc().format(format);
  }

  // 獲取當前本地時間
  getCurrentLocal(format = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs().tz(this.userTimeZone).format(format);
  }
  getTimezoneOffset() {
    return dayjs().tz(this.userTimeZone).format('Z');
  }
  // 檢查是否為有效日期
  isValidDate(date) {
    return dayjs(date).isValid();
  }

  // 計算兩個日期之間的差異（天數）
  dateDiff(date1, date2) {
    return dayjs(date1).diff(dayjs(date2), 'day');
  }

  // 添加時間
  addTime(date, amount, unit = 'day') {
    return dayjs(date).add(amount, unit).format('YYYY-MM-DD HH:mm:ss');
  }

  // 減少時間
  subtractTime(date, amount, unit = 'day') {
    return dayjs(date).subtract(amount, unit).format('YYYY-MM-DD HH:mm:ss');
  }

  // 獲取相對時間（例如：3 小時前）
  getRelativeTime(date) {
    return dayjs(date).fromNow();
  }
}

export const timeConverter = new TimeConverter();